<mat-sidenav-container hasBackdrop="true" class="mx-auto p-0 -mt-px flex-auto border-t pt-0 sm:pt-0">
    <div class="mx-auto flex w-full flex-wrap p-4">
        <div class="flex flex-col sm:flex-row w-full mb-4 items-center justify-between">
            <div>
                <div class="flex items-center gap-1">
                    <div hoverMenu hoverDelay="50" #hoverDirective="hoverMenu" [matMenuTriggerFor]="infoMenu">
                        <button mat-icon-button color="primary">
                        <mat-icon svgIcon="heroicons_outline:exclamation-circle"></mat-icon>
                        </button>
                    </div>
                    <mat-menu [hasBackdrop]="false" [overlapTrigger]="false" class="w-full" #infoMenu="matMenu">
                        <div class="p-4">
                        <p>
                            Saldos pendientes por cliente. Muestra facturas
                            sin pagar y pagos no aplicados. Úsalo para 
                            identificar deudas, aplicar pagos y priorizar 
                            la gestión de cobro.
                        </p>
                        </div>
                    </mat-menu>
                    <h2 class="text-xl font-semibold leading-8 tracking-tight">
                        Partidas Abiertas
                    </h2>
                </div>
                <div class="text-sm text-secondary font-medium tracking-tight">
                    Visualiza y exporta las <b>partidas abiertas</b> asociadas a los <b>socios de negocio</b>.
                </div>
            </div>
            <!-- Header -->
            <div class="relative flex flex-0 flex-col px-4 py-2 sm:flex-row sm:items-center sm:justify-between">
                <div class="flex shrink-0">
                    <!-- Title -->
                    <!--<div class="text-3xl font-extrabold tracking-tight">Stock al Momento</div> -->
                    <!-- Search -->
                    <!-- <mat-form-field class="fuse-mat-dense fuse-mat-rounded min-w-64" subscriptSizing="dynamic">
                  <mat-icon class="icon-size-5" matPrefix svgIcon="heroicons_solid:magnifying-glass"></mat-icon>
                  <--V1 <input matInput placeholder="Buscar" autocomplete="off" (input)="applyFilter($event.target.value)" />--
                  <input matInput placeholder="Buscar" autocomplete="off" [formControl]="searchControl" />
              </mat-form-field> -->
                </div>
                <!-- Actions -->
                <div class="mt-6 flex shrink-0 items-center space-x-3 sm:ml-4 sm:mt-0">
                    <button class="ml-3 hidden sm:inline-flex" mat-flat-button [color]="'primary'"
                        (click)="openExportSidenav()" matTooltip="Exportar">
                        <mat-icon class="icon-size-5" [svgIcon]="'heroicons_outline:document-arrow-down'"></mat-icon>
                        <span class="ml-2">Exportar</span>
                    </button>
                </div>
            </div>
        </div>
        <div
            class="bg-card flex flex-auto flex-col overflow-hidden rounded-2xl shadow xl:col-span-2 dark:bg-transparent">
            <!-- Main Content (Table and Paginator) -->
            <div class="pt-1 mx-6">
                <!-- Tabla -->
                <div class="flex flex-col flex-1 min-h-0 overflow-auto" style="height: calc(100vh - 270px)">
                    <!-- Header -->
                    <div class="overflow-auto flex-1 dark:bg-gray-900">
                        <table class="w-full bg-transparent" mat-table [dataSource]="dataSource" matSort
                            (matSortChange)="changeSort($event)">

                            <ng-container matColumnDef="businessPartner">
                                <th mat-header-cell *matHeaderCellDef mat-sort-header class="table-title">Socio de
                                    Negocio</th>
                                <td mat-cell *matCellDef="let element" class="table-text">
                                    <div class="text-content">
                                        <div *ngIf="getCode(element?.businessPartner) as code">
                                            <b class="f-10">{{ code }}</b>
                                        </div>
                                        <span class="font-descrip"> {{element?.businessPartner?.name}}</span>
                                    </div>
                                </td>
                            </ng-container>

                            <ng-container matColumnDef="document">
                                <th mat-header-cell *matHeaderCellDef mat-sort-header class="table-title">Nro. Doc.</th>
                                <td mat-cell *matCellDef="let element" class="table-text">
                                    <div class="text-content">
                                        {{element?.documentType}} - {{element.document}}
                                    </div>
                                </td>
                            </ng-container>

                            <ng-container matColumnDef="codeReason">
                                <th mat-header-cell *matHeaderCellDef mat-sort-header class="table-title">Tipo</th>
                                <td mat-cell *matCellDef="let element" class="table-text">
                                    <div class="text-content">
                                        {{element?.codeReason}}
                                    </div>
                                </td>
                            </ng-container>

                            <ng-container matColumnDef="creationDate">
                                <th mat-header-cell *matHeaderCellDef mat-sort-header class="table-title">Fecha Creación
                                </th>
                                <td mat-cell *matCellDef="let element" class="table-text">
                                    <div class="text-content">
                                        {{element?.creationDate | FormatDateHour: false }}
                                    </div>
                                </td>
                            </ng-container>

                            <ng-container matColumnDef="expirationDate">
                                <th mat-header-cell *matHeaderCellDef mat-sort-header class="table-title">Fecha
                                    Vencimiento</th>
                                <td mat-cell *matCellDef="let element" class="table-text">
                                    <div class="text-content">
                                        {{element?.expirationDate | FormatDateHour: false }}
                                    </div>
                                </td>
                            </ng-container>

                            <ng-container matColumnDef="availableDays">
                                <th mat-header-cell *matHeaderCellDef class="table-title text-right"
                                    arrowPosition="before">Días <br> Vencidos</th>
                                <td mat-cell *matCellDef="let element" class="table-text text-right">
                                    <div class="text-content">
                                        {{ getExpiredDays(element?.expirationDate) }}
                                    </div>
                                </td>
                            </ng-container>

                            <ng-container matColumnDef="paymentConditionShort">
                                <th mat-header-cell *matHeaderCellDef mat-sort-header class="table-title">Condición <br>
                                    de Pago</th>
                                <td mat-cell *matCellDef="let element" class="table-text">
                                    <div class="text-content">
                                        <div *ngIf="getCode(element?.paymentConditionShort) as code">
                                            <b class="f-10">{{ code }}</b>
                                        </div>
                                        {{element?.paymentConditionShort?.name}}
                                    </div>
                                </td>
                            </ng-container>

                            <ng-container matColumnDef="additionalOC">
                                <th mat-header-cell *matHeaderCellDef mat-sort-header class="table-title">Referencia
                                </th>
                                <td mat-cell *matCellDef="let element" class="table-text">
                                    <div class="text-content">
                                        {{element.reference && element?.additionalOC ? element.reference + ' - ' +
                                        element?.additionalOC : (element.reference || element?.additionalOC)}}
                                    </div>
                                </td>
                            </ng-container>

                            <ng-container matColumnDef="totalAmount">
                                <th mat-header-cell *matHeaderCellDef mat-sort-header class="table-title text-right"
                                    arrowPosition="before">Total {{ 'code' | companyCurrency: true }}</th>
                                <td mat-cell *matCellDef="let element" class="table-text text-right">
                                    <div class="text-content">
                                        {{element.totalAmount | decimalFormat}}
                                    </div>
                                </td>
                            </ng-container>

                            <ng-container matColumnDef="balance">
                                <th mat-header-cell *matHeaderCellDef mat-sort-header class="table-title text-right"
                                    arrowPosition="before">Saldo {{ 'code' | companyCurrency: true }}</th>
                                <td mat-cell *matCellDef="let element" class="table-text text-right">
                                    <div class="text-content">
                                        {{element.balance | decimalFormat}}
                                    </div>
                                </td>
                            </ng-container>

                            <ng-container matColumnDef="statusId">
                                <th mat-header-cell *matHeaderCellDef class="table-title">Estado</th>
                                <td mat-cell *matCellDef="let businessPartnerFunction" class="table-text">

                                </td>
                            </ng-container>

                            <!-- Header Row -->
                            <tr mat-header-row *matHeaderRowDef="displayedColumns"
                                class="sticky top-0 z-10  bg-white dark:bg-gray-900"></tr>
                            <tr mat-row *matRowDef="let row; columns: displayedColumns;" class="border-b"
                                [ngClass]="{'expired-row': getExpiredDays(row?.expirationDate) > 0}"></tr>
                        </table>
                    </div>
                    <div *ngIf="this.dataSource.data.length === 0" class="border-t p-8 text-center text-1xl sm:p-10">Lo
                        sentimos, no hay registros para mostrar.
                    </div>
                </div>

                <div class="flex-shrink-0 bg-gray-100 dark:bg-gray-900 border-b">
                    <mat-paginator class="z-10" [pageSizeOptions]="[50, 100, 150, 200]" showFirstLastButtons
                        [length]="totalItems" [pageSize]="pageSize" (page)="changePage($event)"></mat-paginator>
                </div>
            </div>
        </div>
    </div>

    <!-- Filtros -->
    <app-filter (onFilterEvent)="onFilter()" (onCleanEvent)="onClearFilter()">

        <app-filter-section title="Rango de fechas" [expanded]="true">
            <app-dates-filters [form]="form" [showDateCreationRange]="true"
                [showExpirationDateRange]="true"></app-dates-filters>
        </app-filter-section>

        <app-filter-section title="Configuración" [expanded]="false" (onExpanded)="onConfigExpanded()">
            <app-configuration-filters [form]="form" [company]="true" [salesOffice]="true" [loadData]="loadConfigData"></app-configuration-filters>
        </app-filter-section>


        <app-filter-section title="Gestión de rutas" [expanded]="false" (onExpanded)="onRoutesExpanded()">
            <app-routes-filters [form]="form" [route]="true" [loadData]="loadRoutesData"></app-routes-filters>
        </app-filter-section>

        <app-filter-section title="Socio de negocio" [expanded]="false" (onExpanded)="onBusinessPartnersExpanded()">
            <app-business-partners-filters [form]="form" [businessPartner]="true" [loadData]="loadBusinessPartnersData"></app-business-partners-filters>
        </app-filter-section>

        <app-filter-section title="Finanzas" [expanded]="false" (onExpanded)="onFinanceExpanded()">
            <app-finance-filters [form]="form" [bankList]="bankList"
            [paymentConditionList]="paymentConditionList"
            ></app-finance-filters>
        </app-filter-section>
    </app-filter>
</mat-sidenav-container>